import React, { useState, useMemo, useCallback } from "react";
import { SortableTreeWithoutDndContext as SortableTree } from "react-sortable-tree";
// import FileExplorerTheme from "react-sortable-tree-theme-minimal";
import FileExplorerTheme from "react-sortable-tree-theme-file-explorer";
import "react-sortable-tree/style.css";
import GlobalState from "../../useGlobalState";

const getNodeKey = ({ treeIndex }) => treeIndex;
function DomTree() {
  const { state, dispatch } = GlobalState.useContainer();
  const [searchFocusIndex, setSearchFocusIndex] = useState(0);

  ///////-----SEARCH-------
  // Case insensitive search of `node.title`
  const customSearchMethod = ({ node, searchQuery }) => {
    return (
      searchQuery &&
      node.id.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1
    );
  };

  const onTreeChangeHandler = useCallback(
    (treeData) =>
      dispatch({
        type: "REPLACE_TREE_DATA",
        payload: {
          newTreeData: treeData,
        },
      }),
    [dispatch]
  );

  return useMemo(
    () => (
      <div className="App border-2">
        <SortableTree
          canNodeHaveChildren={(node) => !node.childrenLess}
          // theme={FileExplorerTheme}
          dndType={"yourNodeType"}
          //
          // Custom comparison for matching during search.
          // This is optional, and defaults to a case sensitive search of
          // the title and subtitle values.
          // see `defaultSearchMethod` in https://github.com/frontend-collective/react-sortable-tree/blob/master/src/utils/default-handlers.js
          searchMethod={customSearchMethod}
          //
          // The query string used in the search. This is required for searching.
          searchQuery={state.searchString}
          //
          // When matches are found, this property lets you highlight a specific
          // match and scroll to it. This is optional.
          searchFocusOffset={searchFocusIndex}
          //
          // This callback returns the matches from the search,
          // including their `node`s, `treeIndex`es, and `path`s
          // Here I just use it to note how many matches were found.
          // This is optional, but without it, the only thing searches
          // do natively is outline the matching nodes.
          searchFinishCallback={(matches) => {
            // setSearchFoundCount(matches.lengt);
            const indexToFocusOn =
              matches.length > 0 ? searchFocusIndex % matches.length : 0;
            if (matches[indexToFocusOn]) {
              setSearchFocusIndex(indexToFocusOn);

              dispatch({
                type: "CHANGE_SELECTED_NODE_PATH",
                payload: matches[indexToFocusOn].node,
              });
            }
          }}
          getNodeKey={getNodeKey}
          treeData={state.treeData}
          onChange={onTreeChangeHandler}
          generateNodeProps={({ node, path, ...rest }) => ({
            buttons: [
              // <button
              //   className="bg-red-400 hover:bg-gray-100 text-gray-800 font-semibold py-1 px-2 border border-gray-400 rounded shadow"
              //   onClick={() =>
              //     dispatch({
              //       type: "REMOVE_NODE_UNDER_TREE_DATA_AT_PATH",
              //       payload: {
              //         path: path,
              //       },
              //     })
              //   }
              // >
              //   X
              // </button>,
              <button
              className=" cursor-pointer bg-red-700 rounded-full text-white p-1 mx-1 "
              onClick={() =>
                dispatch({
                  type: "REMOVE_NODE_UNDER_TREE_DATA_AT_PATH",
                  payload: {
                    path: path,
                  },
                })}
            >
              <svg
                className="w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          
            ],
            style: {
              color: node.id === state.selectedNode?.id && "red",
            },
            className: "cursor-pointer font-mono",
            onClick: () => {
              if (state.searchTerm !== node.id)
                dispatch({
                  type: "CHANGE_TREE_SEARCH_TERM",
                  payload: {
                    searchTerm: node.id,
                  },
                });
            },
          })}
        />
      </div>
    ),
    [state.treeData, state.selectedNode?.id, state.searchString, dispatch]
  );
}

export default DomTree;
